module.exports = __webpack_public_path__ + "media/images/spinner-709c24c05182c85d827699dac6d535b2.gif";